import React from "react";
import { Chip, withStyles } from "@material-ui/core";
import { themeTypeToBool } from '../../utils/helpers';

export const StyledChip = withStyles(theme => ({
    root: {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        marginBottom: 5,
        marginTop: 0,
        background: "#43425D",
        color: themeTypeToBool(theme.palette.type) ? "#FFF" : "inherit",
        "&:hover" : {
            background: "#43425D",
            opacity: 0.7
        },
        "&:focus":{
            background: "#43425D"
        },
    },
    deleteIcon: {
        color: themeTypeToBool(theme.palette.type) ? "#FFF" : "inherit",
        marginLeft: theme.spacing(0.5),
        "&:hover" : {
            color: themeTypeToBool(theme.palette.type) ? "#FFF" : "inherit",
        },
    }
}))(props => <Chip clickable={true} {...props} />);